// Copyright © 2022 Move Closer

import { HeadingVariant } from './Heading.contracts'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const DEFAULT_VARIANT: HeadingVariant = HeadingVariant.Large
